import { StarRating } from 'components/Blocks/Reviews/StarRating';
import dayjs from 'dayjs';
import { useFormatDate } from 'hooks/formatting/useFormateDate';
import useTranslation from 'next-translate/useTranslation';
import { MinusIcon, PlusIcon } from 'public/svg/IconsSvg';
import { twJoin } from 'tailwind-merge';
import { ReviewType } from 'types/review';

type ProductReviewItemProps = {
    review: ReviewType;
};

export const ProductReviewItem = ({ review }: ProductReviewItemProps) => {
    const { t } = useTranslation();
    const isCzechReview = [1, 2].includes(review.domainId);
    const isSlovakReview = [3, 4].includes(review.domainId);
    const { formatDateAndTime } = useFormatDate();

    return (
        <div className="flex flex-col space-y-4 pb-6 lg:flex-row lg:space-y-0">
            <div className="flex basis-1/5 flex-col items-start justify-start pb-2">
                <StarRating className="pb-2" rating={review.rating} type="small" />
                <div className="flex flex-col text-small">
                    <span>{formatDateAndTime(dayjs(review.createdAt))}</span>
                    {isCzechReview && review.reviewSource === 'heureka' && <span>{t('Taken from Heureka.cz')}</span>}
                    {isSlovakReview && review.reviewSource === 'heureka' && <span>{t('Taken from Heureka.sk')}</span>}
                    {review.author && <span className="font-bold">{review.author}</span>}
                </div>
            </div>
            <div className="flex basis-4/5 flex-col space-y-2">
                <div className="whitespace-pre-line">{review.summary}</div>
                {review.pros.length + review.cons.length > 0 && (
                    <div className="flex flex-col space-y-2 md:flex-row md:space-y-0">
                        <div className="flex basis-1 flex-row space-x-2 text-green md:basis-1/2 lg:basis-2/5">
                            <PlusIcon
                                className={twJoin('h-4 w-4 basis-1/6', review.pros.length > 0 ? 'block' : 'hidden')}
                            />
                            <div className="flex basis-5/6 flex-col space-y-1">
                                {review.pros.map((pro: string, proIndex) => {
                                    return <span key={`pro-${proIndex}`}>{pro}</span>;
                                })}
                            </div>
                        </div>
                        <div className="flex basis-1 flex-row space-x-2 text-red md:basis-1/2 lg:basis-2/5">
                            <MinusIcon
                                className={twJoin('h-4 w-4 basis-1/6', review.cons.length > 0 ? 'block' : 'hidden')}
                            />
                            <div className="flex basis-5/6 flex-col space-y-1">
                                {review.cons.map((con: string, conIndex) => {
                                    return <span key={`con-${conIndex}`}>{con}</span>;
                                })}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
